import React, { createContext, useReducer } from 'react';
import gql from 'graphql-tag';
import client from '../utils/GQLAdmissionClient';
import axios from 'axios';

const initialCreateState = {
  isCreated: false,
  isInitialised: false,
  user: null,
  users: null
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'INITIALISE': {
      const { isCreated, user } = action.payload;

      return {
        ...state,
        isCreated,
        isInitialised: true,
        user
      };
    }

    case 'UPDATE_INSTITUTION': {
      const { user, updatesuccessfull } = action.payload;

      return {
        ...state,
        updatesuccessfull,
        user
      };
    }
    case 'UPDATE_INSTITUTION_ERR': {
      const { err, updatesuccessfull } = action.payload;

      return {
        ...state,
        updatesuccessfull: false,
        err
      };
    }
    case 'ADD_IMPORT': {
      const { user1, updatesuccessfull1 } = action.payload;

      return {
        ...state,
        updatesuccessfull1,
        user1
      };
    }
    case 'ADD_IMPORT_ERROR': {
      const { err1, updatesuccessfull1 } = action.payload;

      return {
        ...state,
        updatesuccessfull1: false,
        err1
      };
    }
    default: {
      return { ...state };
    }
  }
};

const FeeSetupContext = createContext({
  ...initialCreateState,
 
  addLessonPlan: () => Promise.resolve(),
 
});

export const FeeSetupProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialCreateState);


  const addLessonPlan = async data => {
    console.log("data" , data)

    try {
      let response;
      if (process.env.REACT_APP_ENV === 'test') {
        response = await axios.post(
          'https://documentapi.rovelabs.com/test/import_questions_answered',
          data
        );
      } else {
        response = await axios.post(
          'https://documentapi.rovelabs.com/prod/import_questions_answered',
          data
        );
      }
      console.log("response" , response)
      dispatch({
        type: 'UPDATE_INSTITUTION',
        payload: {
          user: response.data,
          updatesuccessfull: true
        }
      });
    } catch (err) {
      
      if (err.response) {
        dispatch({
          type: 'UPDATE_INSTITUTION_ERR',
          payload: {
            err: err.response.data,
            updatesuccessfull: false
          }
        });
      }
      
    }
  };







  return (
    <FeeSetupContext.Provider
      value={{
        ...state,
        addLessonPlan,
      }}
    >
      {children}
    </FeeSetupContext.Provider>
  );
};

export default FeeSetupContext;
